// The payload is the deleted user's id, wrapped in an object: synapse's `DefaultPayload` requires
// `payload` to be a record (or an array of records), never a bare primitive.
export type UserDeletedPayload = {
	userId: number;
};

export type UserDeletedAction = {
	type: 'USER_DELETED';
	payload: UserDeletedPayload;
	accountId: number;
};

export default (payload: UserDeletedPayload, accountId: number): UserDeletedAction => ({
	type: 'USER_DELETED',
	payload,
	accountId,
});
